export default __webpack_public_path__ + "static/media/logo.c8fa151c.svg";